module.exports = __webpack_public_path__ + "img/renovation-fun-des.207733c6.png";